import { appData } from '@/mocks/homeData';

export default function SectionApp() {
  return (
    <section id="app" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14 max-w-5xl mx-auto">
          <div className="w-full lg:w-2/5 flex justify-center">
            <div className="w-48 md:w-56 aspect-[3/4] rounded-2xl overflow-hidden shadow-lg">
              <img
                src={appData.image}
                alt="黑料吃瓜网移动端"
                title="黑料吃瓜网 - 移动端体验"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
            </div>
          </div>
          <div className="w-full lg:w-3/5 text-center lg:text-left">
            <span className="inline-block px-4 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
              移动体验
            </span>
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">{appData.title}</h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0">
              {appData.description}
            </p>
            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-3">
              {appData.features.map((feat) => (
                <span
                  key={feat}
                  className="px-4 py-2 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap"
                >
                  {feat}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}